<template>
  <b-form-group>
    <h6 v-if="!titleHidden" class="font-size-md text-mcf-color w-100"><span v-if="required" class="text-danger ml-n1">*</span>{{ $t('personal-info.mobile') }}</h6>
    <div v-if="true" class=" font-size-base text-mcf-color">{{ `+${selectedCountryNo} ${phoneNumber}` }}</div>
    <b-input-group v-else>
      <b-input-group-prepend>
        <b-button variant="light" id="popover-code" class="border bg-white d-flex align-items-center">
          <span>{{ selectedCountryNo ? '+' + selectedCountryNo  :$t('personal-info.calling-code') }}</span>
          <span class="material-icons md-18">arrow_drop_down</span>
        </b-button>
        <b-popover target="popover-code" triggers="click blur" :show.sync="pop1" placement="bottom" >
          <div class="overflow-y font-size-md" style="height:220px"><!-- 套漂亮卷軸 -->
            <b-form-group>
              <div class="input-icon">
                <b-input class="w-100" type="text" v-on:click="popOpen" :placeholder="$t('personal-info.enter-country-or-code')" v-model="searchData"></b-input>
                <div class="input-icon-group">
                  <a><i class="material-icons text-secondary" v-show="pop2">search</i></a><!-- 點擊後切換成 visibility -->
                </div>
              </div>
            </b-form-group>
            <b-list-group
              v-for="countryandno in countryandnos"
              :key="countryandno.country">
              <b-list-group-item button class="border-0 p-2 d-flex justify-content-between"
                v-model="phoneNumber"
                v-on:click="selectedCountryAndNo(countryandno)"
                :value="countryandno"
                :key="countryandno.country"
                @click="popClose(countryandno)"
                @blur="verifierAccount">
                  <div>{{ countryandno.lang }}</div>
                  <div class="text-right">+{{ countryandno.code }}</div>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-popover>
      </b-input-group-prepend>
      <b-input
        v-model="phoneNumber"
        @blur="verifierAccount"
        class="bg-white"
        :state="validateState"
        :placeholder="$t('personal-info.mobile-number')"
        type="text"
        maxlength="20">
      </b-input>
    </b-input-group>
    <b-form-invalid-feedback class="w-100 invalid-feedback d-block" v-if="!validateState" :state="validateState">{{ errorMessage }}</b-form-invalid-feedback>
    <slot name="bottom"></slot>
  </b-form-group>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import libphonenumber from 'google-libphonenumber';

const phoneFormat = libphonenumber.PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

export default {
  created() {
    // eslint-disable-next-line global-require
    const mycode = require('@/data/countrycode.json');
    this.countrys = phoneUtil.getSupportedRegions();
    this.countrys.forEach((item, index) => {
      const multilangcountry = this.$t(`country-code.${item}`);
      const region = {
        country: item,
        code: mycode[index].code,
        lang: multilangcountry,
      };
      this.countryandnos_default[index] = region;
    });
    this.countryandnos = this.countryandnos_default;
    this.browserLanguage = navigator.language;
  },
  data() {
    return {
      validateState: undefined,
      browserLanguage: '',
      errorMessage: '',
      countrys: [],
      countryandnos: [],
      countryandnos_default: [],
      searchData: '',
      pop1: false,
      pop2: false,
    };
  },
  computed: {
    ...mapState('memberSource', ['normalRegrType']),
    // 是否為繁體中文
    isTraditionalChinese() {
      return this.browserLanguage.toLowerCase() === 'zh-tw';
    },
    selectedCountry: {
      get() {
        if (this.answer.mobileCountry) {
          return this.answer.mobileCountry;
        }
        // 若未填國家國別代碼且瀏覽器語系為繁體，預帶 TW
        if (this.isTraditionalChinese) {
          this.updateData('mobileCountry', 'TW');
          return 'TW';
        }
        return '';
      },
      set(value) {
        this.updateData('mobileCountry', value);
      },
    },
    selectedCountryNo: {
      get() {
        if (this.answer.callingCode) {
          return this.answer.callingCode;
        }
        // 若未填國際碼且瀏覽器語系為繁體，預帶 886
        if (this.isTraditionalChinese) {
          this.updateData('callingCode', '886');
          return '886';
        }
        return null;
      },
      set(value) {
        this.updateData('callingCode', value);
      },
    },
    phoneNumber: {
      get() {
        if (this.answer.mobile) {
          return this.answer.mobile;
        }
        return '';
      },
      set(value) {
        this.updateData('mobile', value);
      },
    },
  },
  methods: {
    ...mapMutations('memberSource', ['setMemberSourceData']),
    updateData(target, value) {
      const data = { ...this.answer };
      data[target] = value;
      this.$emit('updateData', { id: this.id, value: data });
    },
    verifierAccount() {
      this.setMemberSourceData({ id: 'clickBtn', value: false });
      if (this.validate()) {
        if (this.normalRegrType === 'Mobile' && this.$route.name === 'signup') {
          this.setMemberSourceData({ id: 'doVerifierAccount', value: true });
        }
      }
    },
    RemoveZero() {
      if (this.selectedCountry === 'TW') {
        if (this.phoneNumber.length > 1) {
          const phoneNumberRae = /[^0-9]/;
          if (!phoneNumberRae.test(this.phoneNumber)) {
            const number = phoneUtil.parseAndKeepRawInput(
              this.phoneNumber,
              this.selectedCountry,
            );
            if (phoneUtil.isValidNumber(number)) {
              const replaceNumber = phoneUtil.format(number, phoneFormat.E164);
              const data = { ...this.answer };
              data.mobile = replaceNumber
                .replace(/\+/, '')
                .replace(this.selectedCountryNo, '');
              setTimeout(() => {
                this.$emit('updateData', { id: this.id, value: data });
              }, 1);
            }
          }
        }
      }
    },
    validate() {
      const phoneNumberRae = /[^0-9]/;
      // 必填
      if (this.required) {
        if (this.selectedCountry !== '' && this.phoneNumber !== '') {
          // 如果全部都數字
          if (!phoneNumberRae.test(this.phoneNumber)) {
            const number = phoneUtil.parseAndKeepRawInput(
              this.phoneNumber,
              this.selectedCountry,
            );
            if (phoneUtil.isValidNumber(number)) {
              this.validateState = true;
              this.validateDone();
              return true;
            }
            this.errorMessage = this.$t('personal-info.wrong-mobile');
            this.validateState = false;
            this.validateDone();
            return false;
          }
          // 有除了數字以外的字元
          this.errorMessage = this.$t('personal-info.wrong-mobile');
          this.validateState = false;
          this.validateDone();
          return false;
        }
        this.errorMessage = this.$t('personal-info.please-enter-mobile-Info');
        this.validateState = false;
        this.validateDone();
        return false;
        // 非必填，兩個值都填或兩個值都不填
      }
      // 兩個值都填
      if (this.selectedCountry !== '' && this.phoneNumber !== '') {
        // 如果全部都數字
        if (!phoneNumberRae.test(this.phoneNumber)) {
          const number = phoneUtil.parseAndKeepRawInput(
            this.phoneNumber,
            this.selectedCountry,
          );
          if (phoneUtil.isValidNumber(number)) {
            this.validateState = true;
            this.validateDone();
            return true;
          }
          this.errorMessage = this.$t('personal-info.wrong-mobile');
          this.validateState = false;
          this.validateDone();
          return false;
        }
        // 有除了數字以外的字元
        this.errorMessage = this.$t('personal-info.wrong-mobile');
        this.validateState = false;
        this.validateDone();
        return false;
      }
      // 兩個值都沒填，直接成功
      if (this.selectedCountry === '' && this.phoneNumber === '') {
        this.validateState = true;
        this.validateDone();
        return true;
      }
      // 非必填，又只填了一個欄位
      this.errorMessage = this.$t('personal-info.please-enter-mobile-Info');
      this.validateState = false;
      this.validateDone();
      return false;
    },
    CountryChange() {
      this.RemoveZero();
      setTimeout(() => {
        this.verifierAccount();
      }, 1);
    },
    setErrorMessageFromOutside(payload) {
      this.errorMessage = payload.errorMessage;
      this.validateState = payload.validateState;
    },
    validateDone() {
      this.$emit('validateDone', {
        state: this.validateState,
        wording: this.errorMessage,
      });
    },
    selectedCountryAndNo(value) {
      this.selectedCountry = value.country;
    },
    popClose(value) {
      this.selectedCountry = value.country;
      this.$nextTick(() => {
        this.RemoveZero();
        this.pop1 = false;
      });
    },
    popOpen() {
      this.RemoveZero();
      this.pop2 = true;
    },
  },
  props: {
    id: {
      type: String,
    },
    answer: {
      type: Object,
    },
    required: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
    titleHidden: {
      type: Boolean,
    },
  },
  watch: {
    selectedCountry() {
      if (this.selectedCountry !== '') {
        // 列表取得國碼
        const countryandno = this.countryandnos.filter((item) => item.country === this.selectedCountry);
        this.selectedCountryNo = countryandno[0].code;
      } else {
        this.selectedCountryNo = '';
      }
    },
    phoneNumber() {
      this.RemoveZero();
    },
    searchData() {
      const searchresult = [];
      if (this.searchData === '') {
        this.countryandnos = this.countryandnos_default;
        // this.pop2 = false;
      } else {
        // eslint-disable-next-line array-callback-return
        this.countryandnos_default.map((item) => {
          if (item.lang.toUpperCase().indexOf(this.searchData.toUpperCase()) !== -1
            || item.country.indexOf(this.searchData.toUpperCase()) !== -1
            || '+'.concat(String(item.code)).indexOf(this.searchData) !== -1) {
            searchresult.push(item);
          }
        });
        if (searchresult !== []) {
          this.countryandnos = [];
          this.countryandnos = searchresult;
          // this.pop2 = true;
        } else {
          this.countryandnos = this.countryandnos_default;
          // this.pop2 = false;
        }
      }
      return this.countryandnos;
    },
  },
};
</script>
